import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash, PartyPopper } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
export function AdditionalPaymentThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'התשלום התקבל! - Water Tribe Fest 2026';
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-cyan-50 to-white" dir="rtl" data-id="element-974" data-mp="1kfnrl3cr4yg1">
      <Navigation data-id="element-975" data-mp="1fgkmjiwrus82" />

      <div className="container mx-auto px-4 py-20" data-id="element-976" data-mp="1fh46f55zfqoq">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-977" data-mp="1u4ffn0eoyylo">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-978" data-mp="2342h1m7f84eq">
            <div className="bg-cyan-100 rounded-full p-6" data-id="element-979" data-mp="2d176pw0h6i0a">
              <CheckCircle className="w-20 h-20 text-cyan-600" data-id="element-980" data-mp="285rut9m12w6i" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-981" data-mp="ird8sx2e9nep">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-982" data-mp="17fwod2g2hsp5">
              מעולה {name}! 🌊
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-983" data-mp="1ce7yzfe6s78f">
              התשלום התקבל בהצלחה — מקומך בפסטיבל מובטח!
            </p>
          </motion.div>

          {/* Upgraded Dates Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45
        }} className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-6 md:p-8 shadow-lg mb-8 text-white text-center" data-id="element-984" data-mp="1mce1nz7thhec">
            <Calendar className="w-10 h-10 mx-auto mb-4 text-cyan-200" data-id="element-985" data-mp="203it4e1173dl" />
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-986" data-mp="254gj3csa91pn">
              נתראה בתאריכים החדשים!
            </h2>
            <p className="text-3xl md:text-4xl font-black text-cyan-200 mb-3" data-id="element-987" data-mp="2a42v5iwdkbwv">
              19-21 בנובמבר 2026
            </p>
            <p className="text-cyan-100 text-lg" data-id="element-988" data-mp="3umdhtlh2wk3b">
              חוף מעגן עדן, כנרת — שיא העונה 🌞
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-cyan-200 mb-8" data-id="element-989" data-mp="3knef0jizvio8">
              <div className="flex items-center gap-3 mb-4" data-id="element-990" data-mp="c8472usfbj8j">
                <div className="bg-cyan-100 rounded-full p-2" data-id="element-991" data-mp="7gcq9bz2krvl">
                  <Hash className="w-6 h-6 text-cyan-600" data-id="element-992" data-mp="7ejitugmu3mj" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-993" data-mp="2ghyz7bdu0a0">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-994" data-mp="v5xbk1ip4181">
                מספר ההזמנה של תוספת התשלום. שמור אותו לצורך התכתבות.
              </p>

              <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-6 border-2 border-cyan-100" data-id="element-995" data-mp="fmw11t4w2ama">
                <div className="flex items-center justify-between gap-4" data-id="element-996" data-mp="kns3015ojmp2">
                  <div className="flex-1" data-id="element-997" data-mp="5qj9p1wtg8up">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-998" data-mp="5rkjl323ipau">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-cyan-600 tracking-wider" data-id="element-999" data-mp="yef1bs7j3akm">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-cyan-100 hover:bg-cyan-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-1000" data-mp="13fkv7tcxd3vq">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-cyan-600" data-id="element-1001" data-mp="tmnb5isab6v0" /> : <Copy className="w-6 h-6 text-cyan-600" data-id="element-1002" data-mp="tlc7rk2r414f" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-1003" data-mp="1m5u9i1lzkm3s">
            <div className="flex items-start gap-4" data-id="element-1004" data-mp="3gjoibyvgcels">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-1005" data-mp="3bklgsoeokqik">
                <span className="text-2xl" data-id="element-1006" data-mp="2nvj1vobflbrr">⚠️</span>
              </div>
              <div data-id="element-1007" data-mp="2nvsr39onjewe">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-1008" data-mp="2nxdjotreonrm">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-1009" data-mp="2wwh544e1pf9a">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-1010" data-mp="2st2e6iokjeh2">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה ₪240.
                </p>
              </div>
            </div>
          </motion.div>

          {/* WhatsApp Group */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-1011" data-mp="30xtqnd3u2fn6">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1012" data-mp="3eye8a5y0i5f3">לא לשכוח!</h3>
            <div className="flex items-start gap-4" data-id="element-1013" data-mp="3ewbkzto8uqe2">
              <div className="bg-green-100 rounded-full p-2 shrink-0" data-id="element-1014" data-mp="2i9gbyjam5zft">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1015" data-mp="2n6yo0ijxgus1" />
              </div>
              <div data-id="element-1016" data-mp="2r93g3cuq9jck">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-1017" data-mp="2r8jzbzgtd104">
                  קבוצת הווטסאפ של הפסטיבל
                </h4>
                <p className="text-gray-600 mb-2" data-id="element-1018" data-mp="2w0lfhwh3rbvf">
                  הישארו מעודכנים עם כל הפרטים החשובים לקראת הפסטיבל
                </p>
                <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-1019" data-mp="1zg2y5qz189nf">
                  לחצו כאן להצטרפות לקבוצה
                  <ExternalLink className="w-4 h-4" data-id="element-1020" data-mp="1r1ycqmo1e6uf" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Back to Festival Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-1021" data-mp="1i0qcw05vgxy8">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-1022" data-mp="18advggtctkwb">
              <Home className="w-5 h-5" data-id="element-1023" data-mp="13aj64hp893dd" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-1024" data-mp="z7mha993gb0z" />
    </div>;
}